document.addEventListener('DOMContentLoaded', (event) => {
  // if(coordinateCounter == 0){
  //   const sameProductWrapper =  document.getElementById("same-product-coordinate-wrapper");
  //   sameProductWrapper.style.display = 'none';
  // }
});
